import { SlidingRange } from 'components/RangeSlider/RangeSlider';
import { RangeSliderSC as T } from 'components/RangeSlider/RangeSliderSC';
import { TextInputProps } from 'imaginarity-react-ui';
import * as React from 'react';
import InputRange from 'react-input-range';
import { BaseEditItem } from '../GeneralPostEdit';
import { useGPEState } from '../Helpers/UseGPEState';
export interface EditNumberWithSliderProps<T> extends TextInputProps {
    getter: (value: T) => number | undefined;
    min?: number;
    max?: number;
    step?: number;
    zeroAsInfinite?: boolean;
}

const format = (val: number) => {
    if (val === 0)
        return "∞"
    return `${val}`;
}

const EditNumberWithSlider = <T extends BaseEditItem = BaseEditItem>(props: EditNumberWithSliderProps<T>) => {
    const { getter, min, max, step, zeroAsInfinite } = props;
    const { value: val, setValue: setVal } = useGPEState(getter);
    const [curVal, setCurVal] = React.useState<number>(val ?? 0);

    const cMin = min ?? 0;
    const cMax = max ?? 100;
    const setCVal = React.useMemo(() => (val: number | SlidingRange) => {
        if (typeof val === "number")
            setVal(val);
    }, [setVal]);
    React.useEffect(() => {
        setCVal(val ?? 0);
    }, [val, setCVal])

    const slideVal = (val: number | SlidingRange) => {
        if (typeof val === "number")
            setCurVal(val);
    }

    return (
        <T.Container labelSize='0.8em'>
            <InputRange
                step={step}
                draggableTrack={false}
                allowSameValues={false}
                minValue={cMin}
                maxValue={cMax}
                disabled={false}
                formatLabel={zeroAsInfinite ? format : undefined}
                value={curVal ?? cMin}
                onChange={slideVal}
                onChangeComplete={setCVal}
            />
        </T.Container>
    );
}

export default EditNumberWithSlider;
